(() => {
  const FOCUSABLE_SELECTOR = 'a[href], button, input, select, textarea';
  const MARKER = 'data-a11y-hidden-tabindex';

  const syncHiddenFocusables = () => {
    document.querySelectorAll('slideshow-slide[aria-hidden="true"]').forEach((hidden) => {
      hidden.querySelectorAll(FOCUSABLE_SELECTOR).forEach((focusable) => {
        if (focusable.getAttribute('tabindex') === '-1') return;
        focusable.setAttribute('tabindex', '-1');
        focusable.setAttribute(MARKER, '');
      });
    });

    document.querySelectorAll(`[${MARKER}]`).forEach((focusable) => {
      if (focusable.closest('[aria-hidden="true"]')) return;
      focusable.removeAttribute('tabindex');
      focusable.removeAttribute(MARKER);
    });
  };

  new MutationObserver(syncHiddenFocusables).observe(document.body, {
    attributes: true,
    attributeFilter: ['aria-hidden'],
    childList: true,
    subtree: true,
  });

  syncHiddenFocusables();
})();
